import { useEffect, useState } from 'react';
import debounce from 'lodash.debounce';
import Molten from '@leverege/molten';
import { UI } from '@leverege/ui-redux';
import { diff } from '@leverege/array-util';
import { getActiveContractsByCompanyId } from '../util/Interface';
const ContractInfoHiddenDataViewer = props => {
  const {
    data: {
      items
    },
    dispatch
  } = props;
  const [companyIds, setCompanyIds] = useState([]);
  const debouncedUpdateContractInformation = debounce(async () => {
    const systemId = Molten.getConfig('api/systemId');
    const newCompanyIds = [...new Set(items.map(item => item?.data?.data?.company?.id).filter(Boolean))];
    if (!isEqual(companyIds, newCompanyIds)) {
      setCompanyIds(newCompanyIds);
      const contractsByCompanyId = await getActiveContractsByCompanyId(systemId, newCompanyIds);
      dispatch(UI.set('contractsByCompanyId', contractsByCompanyId));
    }
  }, 500);
  useEffect(debouncedUpdateContractInformation, [items]);
  return null;
};
function isEqual(arr1, arr2) {
  const {
    added,
    removed
  } = diff(arr1, arr2);
  return added.length === 0 && removed.length === 0;
}
export default ContractInfoHiddenDataViewer;